import React, { Component, Fragment } from 'react';
import { CloseCircleFilled, QuestionCircleOutlined } from '@ant-design/icons';
import { Checkbox, Radio, Select, Tooltip } from 'antd';
import { createPortal } from 'react-dom';
import Panel from '@/components/Panel';
import TreeSelect from '../../../../components/TreeSelect';
import { getPortByTouchstone } from '../../../../services/helper/getPortByTouchstone';
import InterposerModel from './interposerModel'
import { getTreeSelectList } from '../../../../services/Cascade/library';
import { TOUCHSTONE, SPICE } from '../../../../services/Cascade/constants';
import '../index.css'

const PER_PORT = 'perPort', UNIFIED = 'unified'

function Pair(params) {
  const { pin = '', node = '', designId = '', powerNet = '', port = '', } = params || {}
  this.pin = pin
  this.node = node
  this.designId = designId
  this.powerNet = powerNet
  this.port = port
}

class InterPoserPanel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      apply: true,
      subcktList: [],
      modelType: '',
      touchstoneSpiceList: [],
      interposerType: this.props.interposerType || PER_PORT,
      portList: [],
      pairs: [],
      unifiedPortList: [],
      unifiedPairs: [],
      nodes: []
    }
    this.dialogRoot = document.getElementById('root');
  }

  componentDidMount() {
    this.initData()
  }

  initData = () => {
    const { onDieSpiceList, onDieTouchstoneList, interposer } = this.props
    const { interposerType } = this.state
    const touchstoneSpiceList = [...onDieTouchstoneList, ...onDieSpiceList].map(item => getTreeSelectList(item));
    const fileName = interposer && interposer.fileName ? interposer.fileName : ""
    const libraryId = interposer && interposer.libraryId ? interposer.libraryId : ""
    const subckt = interposer && interposer.subckt ? interposer.subckt : ""
    this.initPortList(interposerType)
    this.setState({
      fileName,
      libraryId,
      subckt,
      touchstoneSpiceList,
    }, () => {
      this.getFileAndParse(interposer)
    })
  }

  initPortList = (type) => {
    const { ICs = [], interposerPowerNet, interposerIndex, interposerDie, pkg } = this.props;
    const portList = [], unifiedPortList = [], pairs = [], unifiedPairs = [];

    const portNameMap = new Map(); // key: `${powerNet}-${portIndex}`, value: portName

    (pkg.powerDomains || []).forEach(domain => {
      const content = domain.content || {};
      const diePorts = content.diePorts && content.diePorts.length ? content.diePorts : [{ port: '1' }];
      const powerNets = content.PowerNets || [];
      const components = content.Components || [];

      const isMatchDie = components.some(c => c.name === interposerDie);
      if (!isMatchDie || !powerNets.length) return;

      const powerNet = powerNets[0];
      diePorts.forEach(item => {
        const key = `${powerNet}-${item.port}`;
        portNameMap.set(key, item.portName || '');
      });
    });

    ICs.forEach(ic => {
      if (ic.to[0].components[0] === interposerDie) {
        const key = `${ic.powerNet}-${ic.portIndex}`;
        const portName = portNameMap.get(key) || '';
        const _pairs = ic.model && ic.model.pairs || []
        const nodeName = _pairs.length ? _pairs[0].node : ''
        const leftPort = { port: ic.portIndex, designId: 'die', powerNet: ic.powerNet, portName: nodeName };
        const rightPort = { port: ic.portIndex, designId: 'pkg', powerNet: ic.powerNet, portName };
        const findIndex = unifiedPortList.findIndex(item => item.net === ic.powerNet)
        if (findIndex > -1) {
          unifiedPortList[findIndex].leftPorts.push(leftPort);
          unifiedPortList[findIndex].rightPorts.push(rightPort);
        } else {
          unifiedPortList.push({
            net: ic.powerNet,
            leftPorts: [leftPort],
            rightPorts: [rightPort],
          });
        }
        if (type === PER_PORT) {
          unifiedPairs.push(...this.initDefaultPairs(ic));
        } else {
          unifiedPairs.push(...this.initPairsFromInterposer(ic));
        }
      }
    });

    const ic = ICs.find(item => item.powerNet === interposerPowerNet && item.portIndex === interposerIndex);
    if (ic) {
      const key = `${ic.powerNet}-${ic.portIndex}`;
      const portName = portNameMap.get(key) || '';
      const _pairs = ic.model && ic.model.pairs || []
      const nodeName = _pairs.length ? _pairs[0].node : ''
      portList.push({
        net: ic.powerNet,
        leftPorts: [{ port: ic.portIndex, designId: 'die', powerNet: ic.powerNet, portName: nodeName }],
        rightPorts: [{ port: ic.portIndex, designId: 'pkg', powerNet: ic.powerNet, portName }],
      });
      if (type === PER_PORT) {
        pairs.push(...this.initPairsFromInterposer(ic));
      } else {
        pairs.push(...this.initDefaultPairs(ic));
      }
    }

    this.setState({
      portList,
      pairs,
      unifiedPortList,
      unifiedPairs
    });
  }

  initDefaultPairs = (ic) => ['diePort', 'pkgPort'].map(pin => new Pair({
    pin,
    designId: pin === 'diePort' ? 'die' : 'pkg',
    powerNet: ic.powerNet,
    port: ic.portIndex,
  }));

  initPairsFromInterposer = (ic) => {
    const { pairs: _pairs = [], libraryId = '', subckt = '' } = ic.interposer || {};
    const result = [];
    if (_pairs.length) {
      _pairs.forEach(item => {
        result.push({
          ...item,
          designId: item.pin === 'diePort' ? 'die' : 'pkg',
          powerNet: ic.powerNet,
          port: ic.portIndex,
          libraryId,
          subckt,
          modelKey: '1',
        });
      });
    } else {
      result.push(...this.initDefaultPairs(ic));
    }
    return result;
  };

  getFileAndParse = (model) => {
    const { touchstoneSpiceList } = this.state
    let nodes = []
    if (model && model.libraryId) {
      const file = touchstoneSpiceList.find(item => item.id === model.libraryId)
      if (file) {
        if (file.modelType === SPICE) {
          this.setState({
            fileName: model.fileName || '',
            libraryId: model.libraryId || '',
            subckt: model.subckt || '',
            modelType: file.modelType,
          })
          try {
            this.props.getPkgSpiceModelList(model.libraryId, model.fileName, 'SPICE').then(res => {
              if (res) {
                const subcktList = res && res.models && Array.isArray(res.models) ? [...res.models] : [];
                this.setState({
                  subcktList: subcktList
                })
                if (model.subckt) {
                  let _subcktList = [...this.state.subcktList];
                  this.setState({
                    subcktList: _subcktList
                  })
                  const _subcktIndex = _subcktList.findIndex(sub => sub.name === model.subckt);
                  if (_subcktList[_subcktIndex] && _subcktList[_subcktIndex].ports) {
                    nodes = _subcktList[_subcktIndex].ports;
                    this.setState({
                      nodes
                    })
                  }
                }
              }
            });
          } catch (error) {
            console.error(error)
          }
        } else if (file.modelType === TOUCHSTONE) {
          nodes = getPortByTouchstone(model.fileName);
          this.setState({
            nodes
          })
        }
      }
    }
  }

  closeModal = () => {
    const { apply, fileName, libraryId, subckt, pairs, unifiedPairs, interposerType } = this.state
    const _pairs = interposerType === PER_PORT ? pairs : unifiedPairs
    const _info = { fileName, libraryId, subckt, pairs: _pairs, interposerType }
    this.props.closeModal(_info, apply)
  }

  changeApply = () => {
    this.setState({
      apply: !this.state.apply
    })
  }

  applyRender = () => {
    const { apply } = this.state;
    return <div className="imp-current-apply">
      <Checkbox
        checked={apply}
        onChange={this.changeApply}
      />
      <span>
        Apply interposer model to all Ports
      </span>
    </div>
  }

  onRef = (ref) => {
    this.modelChild = ref;
  }

  resetPairs = (nodes = []) => {
    const { pairs, unifiedPairs, interposerType, libraryId, subckt } = this.state
    let _pairs = [], _unifiedPairs = []
    if (interposerType === PER_PORT) {
      const dieNode = nodes.find(item => item.match(/(die)/ig))
      const pkgNode = nodes.find(item => item.match(/(pkg|package|bump)/ig))
      _pairs = pairs.map(item => {
        if (item.pin === 'diePort') {
          return {
            ...item,
            node: dieNode ? dieNode : '',
            designId: 'die',
            libraryId,
            subckt,
            modelKey: '1',
          }
        } else if (item.pin === 'pkgPort') {
          return {
            ...item,
            node: pkgNode ? pkgNode : '',
            designId: 'pkg',
            libraryId,
            subckt,
            modelKey: '1',
          }
        }
      })
    } else {
      _pairs = pairs.map(item => new Pair({ ...item, node: "" }))
    }
    _unifiedPairs = unifiedPairs.map(item => new Pair({ ...item, node: "" }))
    this.setState({
      pairs: _pairs,
      unifiedPairs: _unifiedPairs
    })
  }

  selectModelFile = (key) => {
    const { touchstoneSpiceList } = this.state;
    let file = [];
    const name = key.id ? key.name : key;
    if (key.id) {
      file = { ...key }
    } else {
      if (Array.isArray(touchstoneSpiceList)) {
        file = touchstoneSpiceList.find(item => item.name === name);
      }
    }
    if (file) {
      let nodes = []
      this.setState({
        fileName: name,
        subckt: '',
        libraryId: file.id,
        nodes: [],
        modelType: file.modelType
      })
      if (file.modelType === SPICE) {
        try {
          this.props.getPkgSpiceModelList(file.id, file.name, 'SPICE').then(res => {
            let subcktList = [], defaultSubckt = {};
            subcktList = res && res.models && Array.isArray(res.models) ? [...res.models] : [];
            if (subcktList && subcktList.length === 1) {
              defaultSubckt = subcktList[0]
            }
            if (res) {
              this.setState({
                subcktList: subcktList
              })
            }
            if (defaultSubckt && defaultSubckt.name) {
              nodes = defaultSubckt.ports
              this.setState({
                subckt: defaultSubckt.name,
                nodes
              }, () => {
                this.resetPairs(nodes)
              })
            }
          });
        } catch (error) {
          console.error(error)
        }
      } else if (file.modelType === TOUCHSTONE) {
        nodes = getPortByTouchstone(file.name);
        this.setState({
          nodes
        }, () => {
          this.resetPairs(nodes)
        })
      }
    }
  }

  selectSpiceSubckt = (key) => {
    const { subcktList } = this.state;
    const subckt = subcktList.find(item => item.name === key);
    const nodes = subckt ? subckt.ports : []
    this.setState({
      subckt: key,
      nodes
    }, () => {
      this.resetPairs(nodes)
    })
  }

  deleteFileSelect = (target) => {
    if (target === 'file') {
      this.setState({
        nodes: [],
        fileName: '',
        libraryId: '',
        subckt: '',
        subcktList: [],
        modelType: ''
      })
    } else if (target === 'subckt') {
      this.setState({
        nodes: [],
        subckt: ''
      })
    }
    this.resetPairs()
  }

  onChangeCustomType = (e) => {
    e && e.stopPropagation();
    const value = e.target.value;
    this.setState({
      interposerType: value,
    })
  }

  updatePairs = (pairs) => {
    const { interposerType } = this.state
    if (interposerType === PER_PORT) {
      this.setState({
        pairs: pairs
      })
    } else if (interposerType === UNIFIED) {
      this.setState({
        unifiedPairs: pairs
      })
    }
  }

  isFileExist = (list, libraryId) => {
    return list.some(file =>
      file.id === libraryId ||
      (Array.isArray(file.children) && this.isFileExist(file.children, libraryId))
    );
  };

  renderDialog = () => {
    const { ICs = [], overviewReverse } = this.props
    const { fileName, subckt, subcktList, libraryId, interposerType, modelType, touchstoneSpiceList, nodes, portList, pairs, unifiedPortList, unifiedPairs } = this.state
    const selectFile = {
      fileName,
      libraryId,
      subckt,
      modelKey: '1',
      type: modelType,
      nodes
    }
    const fileNotFound = libraryId && !this.isFileExist(touchstoneSpiceList, libraryId) ? true : false;
    const content = (
      <Panel
        className='interposer-panel'
        id='interposer-panel'
        title={'Interposer Model'}
        onCancel={this.closeModal}
        zIndex={2000}
        width={794}
        minWidth={300}
        minHeight={200}
        maxHeight={800}
        position='panel-center-left'
        draggable
        overflow={"auto"}
        footer={interposerType === PER_PORT ? this.applyRender() : null}
      >
        <div className='interposer-content'>
          <div className='interposer-model-select'>
            <span>Interposer Type</span>
            <Radio.Group onChange={(e) => this.onChangeCustomType(e)} value={interposerType} className='interposer-model-type-radio-group'>
              <Radio value={PER_PORT} className='interposer-model-type-radio-value'>
                <Tooltip
                  title='Set interposer model for each port.'
                  classNames={{ root: 'aurora-tooltip' }}
                >
                  Per-port
                </Tooltip>
              </Radio>
              <Radio value={UNIFIED} className='interposer-model-type-radio-value'>
                <Tooltip
                  title='Set a unified interposer model for all ports'
                  classNames={{ root: 'aurora-tooltip' }}
                >
                  Unified
                </Tooltip>
              </Radio>
            </Radio.Group>
          </div>
          <div className='interposer-model-select'>
            <span>Model File</span>
            <TreeSelect
              showSearch
              value={fileName}
              onSelectItem={this.selectModelFile}
              className={`cascaede-model-selection ${modelType === SPICE ? "cascaede-model-selection-50" : ""}`}
              popupClassName='netlist-model-dropdown'
              popupMatchSelectWidth={false}
              allowClear={true}
              clearIcon={<CloseCircleFilled onClick={(e) => { this.deleteFileSelect('file') }} />}
              getPopupContainer={() => document.getElementById('root')}
              fileList={touchstoneSpiceList}
              selected={`${libraryId}-${fileName}`}
              selectedkey={"key"}
              suffixIcon={fileNotFound ? <Tooltip
                title={`The corresponding file was not found, please choose again.`}
              ><QuestionCircleOutlined className='aurora-file-check-icon' /></Tooltip> : null}
            />
            {modelType === SPICE &&
              <Select
                style={{ marginLeft: "10px" }}
                value={subckt}
                onSelect={this.selectSpiceSubckt}
                className='cascaede-model-selection cascaede-model-selection-50'
                popupClassName='netlist-model-dropdown'
                popupMatchSelectWidth={false}
                allowClear={{ clearIcon: <CloseCircleFilled onClick={(e) => { this.deleteFileSelect('subckt') }} /> }}
                getPopupContainer={() => document.getElementById('root')}
                options={subcktList.map(item => ({
                  value: item.name,
                  label: item.name,
                  title: item.disabled ? 'The number of ports should be two' : item.name,
                  disabled: item.disabled
                }))}
              />}
          </div>
          <InterposerModel
            ICs={ICs}
            leftModelTitle={'Die'}
            rightModelTitle={'Package'}
            portList={interposerType === PER_PORT ? portList : unifiedPortList}
            pairs={interposerType === PER_PORT ? pairs : unifiedPairs}
            selectFileList={[selectFile]}
            updatePairs={this.updatePairs}
            resetPairs={this.resetPairs}
            overviewReverse={overviewReverse}
          />
        </div>
      </Panel>
    );
    return createPortal(content, this.dialogRoot);
  }

  render() {
    return <Fragment>
      {this.renderDialog()}
    </Fragment>
  }
}

export default InterPoserPanel;
